import { stipAxios } from '../axios';

const sectorEndpoints = {
    getDirectorsByService: (cdServico) => stipAxios.get(`/setor/diretores-by-servico/${cdServico}`),
    getGeneralDirector: () => stipAxios.get(`/usuario/diretor-geral`),
    getAlternativeDirector: () => stipAxios.get(`/usuario/substituto-diretor-geral`),
    getDirectors: () => stipAxios.get(`/setor/all-diretores`),
    getSectors: () => stipAxios.get(`/setor/find-all`),
    fetchEmployeeBySectorsId: (idList) => stipAxios.post(`/usuario/find-all-by-setores`, { cdSetores: idList }),
    getSectorDepartments: (sector) => stipAxios.get(`/setor/${sector}`),
};

export default sectorEndpoints;
